/**
 *  Plugins
 *
 *  Here's where plugins need to be loaded before starting Vue app, before calling new Vue();
 *
 *  Plugins usually add global-level functionality to Vue.
 *  There is no strictly defined scope for a plugin - there are typically several types of plugins:
 *  1) Add some global methods or properties. e.g. vue-custom-element
 *  2) Add one or more global assets: directives/filters/transitions etc. e.g. vue-touch
 *  3) Add some component options by global mixin. e.g. vue-router
 *  4) Add some Vue instance methods by attaching them to Vue.prototype.
 *  5) A library that provides an API of its own, while at the same time injecting some combination of the above. e.g. vue-router
 */
import "./http";

import carbonPlugin from "./carbon";
import carbonCustomPlugin from "./carbon-custom";
import commonPlugin from "./common";
import mediaPlugin from "./media";
import richtextPlugin from "./richtext";
import fileUploaderv2Plugin from "./file-uploader-v2";
import commentPlugin from "./comment";
import toastPlugin from "./toast";
import VuePlyrPlugin from "./plyr/plyr";
import VueYoutubePlugin from "./youtube";
import rangyPlugin from "./rangy";
import pageDrawerPlugin from "./page-drawer";
import d3Plugin from "./d3";
import contentSubpagePlugin from "./content-subpage";
import contentStickyPlugin from "./content-sticky";
import stpPlugin from "./stp";
import characterCountPlugin from "./character-count";
import otpPlugin from "./otp";
import filterTagPlugin from "./filter-tag";
import cardPlugin from "./card";
import tabsPlugin from "./tabs";
import vLazyComponentPlugin from "./v-lazy-component";
import carouselPlugin from "./carousel";
import modalPlugin from "./modal";
import activityNavigatorPlugin from "./activity-navigator";
import carbonChartPlugin from "./carbon-chart";
import treeStructure from "./tree-structure";
import userTag from "./user-tag";
import wirisModalPlugin from "./wiris-modal";
import pdfViewerPlugin from "./pdf-viewer";

const Plugin = {
  install(app) {
    app.use(carbonPlugin);
    app.use(carbonCustomPlugin);
    app.use(commonPlugin);
    app.use(mediaPlugin);
    app.use(richtextPlugin);
    app.use(fileUploaderv2Plugin);
    app.use(commentPlugin);
    app.use(toastPlugin);
    app.use(VuePlyrPlugin);
    app.use(VueYoutubePlugin);
    app.use(rangyPlugin);
    app.use(pageDrawerPlugin);
    app.use(d3Plugin);
    app.use(contentSubpagePlugin);
    app.use(contentStickyPlugin);
    app.use(stpPlugin);
    app.use(otpPlugin);
    app.use(filterTagPlugin);
    app.use(cardPlugin);
    app.use(tabsPlugin);
    app.use(vLazyComponentPlugin);
    app.use(carouselPlugin);
    app.use(modalPlugin);
    app.use(activityNavigatorPlugin);
    app.use(carbonChartPlugin);
    app.use(treeStructure);
    app.use(userTag);
    app.use(characterCountPlugin);
    app.use(wirisModalPlugin);
    app.use(pdfViewerPlugin);
  },
};

export default Plugin;
